/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
    UserPresentAtlas,
    UserPresentAtlasFromJSON,
    UserPresentAtlasFromJSONTyped,
    UserPresentAtlasToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserPresentAtlasResponse
 */
export interface UserPresentAtlasResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof UserPresentAtlasResponse
     */
    msg: string;
    /**
     * 
     * @type {UserPresentAtlas}
     * @memberof UserPresentAtlasResponse
     */
    entry: UserPresentAtlas;
}

export function UserPresentAtlasResponseFromJSON(json: any): UserPresentAtlasResponse {
    return UserPresentAtlasResponseFromJSONTyped(json, false);
}

export function UserPresentAtlasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPresentAtlasResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': UserPresentAtlasFromJSON(json['entry']),
    };
}

export function UserPresentAtlasResponseToJSON(value?: UserPresentAtlasResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': UserPresentAtlasToJSON(value.entry),
    };
}


